import { render, staticRenderFns } from "./FormModel.vue?vue&type=template&id=54abda2a&scoped=true&"
import script from "./FormModel.vue?vue&type=script&lang=js&"
export * from "./FormModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abda2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54abda2a')) {
      api.createRecord('54abda2a', component.options)
    } else {
      api.reload('54abda2a', component.options)
    }
    module.hot.accept("./FormModel.vue?vue&type=template&id=54abda2a&scoped=true&", function () {
      api.rerender('54abda2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormModel.vue"
export default component.exports